import { i18nTranslationHelper } from '@/i18n'
export namespace ContentInstitutionSearchOrder {
  const t = {
    enums: i18nTranslationHelper.getTEnums
  }
  export class Enum {
    static readonly ALPHABETICAL_ASC = new Enum(
      'ALPHABETICAL_ASC',
      t.enums('contentInstitutionSearchOrder.ALPHABETICAL_ASC.label')
    )
    static readonly ALPHABETICAL_DESC = new Enum(
      'ALPHABETICAL_DESC',
      t.enums('contentInstitutionSearchOrder.ALPHABETICAL_DESC.label')
    )
    static readonly RATING_DESC = new Enum(
      'RATING_DESC',
      t.enums('contentInstitutionSearchOrder.RATING_DESC.label')
    )

    private constructor(
      public readonly name: string,
      public readonly title: string
    ) {}
  }

  export const getByName = (name: string): Enum => {
    return Object.values(ContentInstitutionSearchOrder.Enum).find(type => type.name === name)
  }

  export const getAll = (): Enum[] => {
    return Object.values(ContentInstitutionSearchOrder.Enum)
  }
}
